<template>
  <div class="elevation-6 initial-card pt-10">
    <v-container>
        <div class="d-flex justify-center">
            <img :src="this.logo" alt="logo" height="128">
        </div>
        <div class="px-12">
            <v-form
                ref="form"
                v-model="valid"
                class="d-flex flex-column align-center justify-center"
                >
                <v-text-field
                  v-model="login"
                  :rules="[rules.required, rules.email]"
                  label="Login"
                  required
                  class="fluid"
                ></v-text-field>

                <v-text-field
                    v-model="password"
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required]"
                    :type="show ? 'text' : 'password'"
                    name="password"
                    label="Senha"
                    hint=""
                    counter
                    @click:append="show = !show"
                    class="fluid"
                ></v-text-field>
                <div class="fluid d-flex justify-center">
                    <v-btn
                        :disabled="!valid"
                        color="#1c579a"
                        class="white--text button-primary elevation-2 mt-6"
                        @click="submit"
                    >
                    <v-progress-circular v-if="loading" :indeterminate="true" size="24"></v-progress-circular>
                    <span v-else >Entrar</span>
                        
                    </v-btn>
                </div>

                <router-link to="/esqueci-minha-senha" class="light-blue--text text--darken-4 body-2 decoration-none mt-8">Esqueceu sua senha? Clique aqui</router-link>
            </v-form>
        </div>
        <v-snackbar
            v-model="notification.active"
            :top="true"
            :color="notification.type"
        >
            {{ notification.description }}
             <v-btn
                color="white"
                text
                @click="notification.active = false"
            >
                {{ notification.closeText }}
            </v-btn>
        </v-snackbar>
    </v-container>
  </div>
</template>

<script>
export default {
    data: () => ({
        logo: '',
        loading: false,
        notification: {
            active: false,
            description: '',
            type: '',
            closeText: ''
        },
        valid: true,
        show: false,
        password: '',
        rules: {
            required: value => !!value || 'Este campo é obrigatório.',
            min: v => v.length >= 6 || 'Sua senha precisa ter pelo menos 6 caracteres',
            email: v => /.+@.+\..+/.test(v) || 'E-mail inválido'
        },
        login: '',
        checkbox: false,
    }),
    created() {
        this.loading = true;
        this.valid = false;
        this.$http.get('/subdomain')
        .then(res => {
            this.logo = res.data.logo_login;
        })
        .catch(error => {
            this.showError(error);
        })
        .finally(() => {
            this.loading = false,
            this.valid = true
        })
    },
    methods: {
        submit () {
            this.loading = true;
            this.valid = false;
            if(this.$refs.form.validate()) {
                this.$http
                .post('/token', 
                    "grant_type=password&username="+this.login+"&password="+this.password+""
                )
                .then(res => {
                    localStorage.session = res.data.access_token;
                    localStorage.type = res.data.token_type;
                    localStorage.logo_plataform = res.data.client_preferences.logo_plataform;

                    let client_colors = JSON.parse(res.data.client_preferences.style_params);
                    localStorage.primary_color = client_colors.primary_color;
                    localStorage.secondary_color = client_colors.secondary_color;
                    localStorage.tertiary_color = client_colors.tertiary_color;

                    window.location.href = '/';
                })
                .catch(error => {
                    this.showError(error);
                })
                .finally(() => {
                    this.loading = false,
                    this.valid = true
                })
            }
        },
        showError(error) {
            this.notification = {
                active: true,
                description: error,
                type: 'error',
                closeText: 'Fechar'
            }
        }
  },
}
</script>

<style scoped>

</style>